import React from 'react';
import { MapPin, Instagram, Facebook, Phone, Clock, Mail } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="bg-[#0A0A0A] py-20 md:py-28" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20" data-id="element-15">
          {/* Left: Contact Info */}
          <div className="flex flex-col justify-center" data-id="element-16">
            <img src="https://cdn.magicpatterns.com/uploads/kHPY5hn7jL6QdVkj1vf8yR/raise_the_bar_white.png" alt="Raise The Bar Logo" className="w-[100px] mb-8" data-id="element-17" />

            <div className="space-y-6 text-white/90 mb-10" style={{
            fontFamily: "'Montserrat', sans-serif"
          }} data-id="element-18">
              <div className="flex items-start gap-4" data-id="element-19">
                <MapPin className="w-6 h-6 text-[#C8A84E] flex-shrink-0 mt-1" data-id="element-20" />
                <div data-id="element-21">
                  <p className="font-semibold text-white mb-1" data-id="element-22">Location</p>
                  <p data-id="element-23">
                    1543 W Elliot Rd, Suite 104
                    <br data-id="element-24" />
                    Gilbert, AZ 85233
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-25">
                <Phone className="w-6 h-6 text-[#C8A84E] flex-shrink-0 mt-1" data-id="element-26" />
                <div data-id="element-27">
                  <p className="font-semibold text-white mb-1" data-id="element-28">Phone</p>
                  <p data-id="element-29">(480) 493-5069</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-30">
                <Clock className="w-6 h-6 text-[#C8A84E] flex-shrink-0 mt-1" data-id="element-31" />
                <div data-id="element-32">
                  <p className="font-semibold text-white mb-1" data-id="element-33">Hours</p>
                  <p data-id="element-34">Mon 9am–8pm</p>
                  <p data-id="element-35">Tue–Fri 7am–8pm</p>
                  <p data-id="element-36">Sat 9am–4pm</p>
                  <p data-id="element-37">Sun Closed</p>
                  <p className="text-[#C8A84E] mt-2 italic text-sm" data-id="element-38">
                    By Appointment Only
                  </p>
                </div>
              </div>
            </div>

            <div className="mb-10" data-id="element-39">
              <a href="#book" className="inline-flex items-center justify-center bg-[#C8A84E] hover:bg-[#b39542] text-black px-8 py-4 rounded-full font-semibold transition-all duration-300 transform hover:scale-105 min-h-[48px]" style={{
              fontFamily: "'Montserrat', sans-serif"
            }} data-id="element-40">
                Book Now
              </a>
            </div>

            <div className="flex items-center gap-6" data-id="element-41">
              <a href="#" className="text-[#C8A84E] hover:text-white transition-colors p-2" data-id="element-42">
                <Instagram className="w-6 h-6" data-id="element-43" />
                <span className="sr-only" data-id="element-44">Instagram</span>
              </a>
              <a href="#" className="text-[#C8A84E] hover:text-white transition-colors p-2" data-id="element-45">
                <Facebook className="w-6 h-6" data-id="element-46" />
                <span className="sr-only" data-id="element-47">Facebook</span>
              </a>
              {/* Using Mail as placeholder for TikTok since lucide doesn't have tiktok */}
              <a href="#" className="text-[#C8A84E] hover:text-white transition-colors p-2" data-id="element-48">
                <svg className="w-6 h-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-49">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" data-id="element-50" />
                </svg>
                <span className="sr-only" data-id="element-51">TikTok</span>
              </a>
            </div>
          </div>

          {/* Right: Map Placeholder */}
          <div className="bg-[#1A1A1A] rounded-2xl overflow-hidden min-h-[400px] flex items-center justify-center border border-white/10 relative group" data-id="element-52">
            <div className="absolute inset-0 bg-[url('https://maps.googleapis.com/maps/api/staticmap?center=Gilbert,AZ&zoom=13&size=600x400&maptype=roadmap&style=feature:all|element:labels.text.fill|color:0xffffff&style=feature:all|element:labels.text.stroke|color:0x000000&style=feature:all|element:labels.icon|visibility:off&style=feature:administrative|element:geometry.fill|color:0x000000&style=feature:administrative|element:geometry.stroke|color:0x144b53&style=feature:landscape|element:all|color:0x08304b&style=feature:poi|element:geometry|color:0x0c4152&style=feature:road.highway|element:geometry.fill|color:0x000000&style=feature:road.highway|element:geometry.stroke|color:0x0b434f&style=feature:road.arterial|element:geometry.fill|color:0x000000&style=feature:road.arterial|element:geometry.stroke|color:0x0b3d51&style=feature:road.local|element:geometry|color:0x000000&style=feature:transit|element:all|color:0x146474&style=feature:water|element:all|color:0x021019')] bg-cover bg-center opacity-30 grayscale mix-blend-luminosity" data-id="element-53"></div>
            <div className="relative z-10 text-center flex flex-col items-center" data-id="element-54">
              <div className="bg-[#C8A84E] p-4 rounded-full mb-4 shadow-lg" data-id="element-55">
                <MapPin className="w-8 h-8 text-black" data-id="element-56" />
              </div>
              <p className="text-white font-semibold text-lg" style={{
              fontFamily: "'Montserrat', sans-serif"
            }} data-id="element-57">
                Google Maps
              </p>
              <p className="text-gray-400 text-sm mt-2" data-id="element-58">
                Interactive map disabled in preview
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}